import React, { Component } from "react";

import CountryTranslator from "./CountryTranslator";
import Queries from "../../queries/queries2";
import SimpleSelect from "../../elements/CustomSelect/SimpleSelect";
import Spinner from "../../elements/Spinner/Spinner";
import _ from "lodash-es";
import { graphql } from "react-apollo";

class CountrySelect extends Component {
  render() {
    // console.log("CountrySelect", this.props);

    if (!this.props.GetCountriesQuery) return <Spinner fullScreen />;

    const countries = this.props.GetCountriesQuery.countries;
    let options = [];
    let value = this.props.value;
    if (countries) {
      options = countries.map(country => {
        return {
          label: CountryTranslator.getName(country.label),
          value: country.id
        };
      });
    }

    options = _.sortBy(options, [
      option => {
        const opt = option.label
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
        return opt;
      }
    ]);
    // console.log('countries options', options);

    return (
      <SimpleSelect
        name={"country"}
        value={value}
        onSelected={this.props.onSelected}
        options={options}
        clearable={false}
      />
    );
  }
}

export default graphql(Queries.GetCountries, {
  name: "GetCountriesQuery",
  // fetchPolicy: 'network-only'
  fetchPolicy: "cache-and-network"
})(CountrySelect);
